module.exports = __webpack_public_path__ + "static/img/report_icon2.bd5acb20.png";